import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
export default class ProductVariationOption {
  constructor() {
    _defineProperty(this, "Name", {
      fieldName: 'name',
      content: null
    });
    _defineProperty(this, "Option", {
      fieldName: 'option',
      content: null
    });
  }
  getName() {
    return this.Name.content;
  }
  setName(name) {
    this.Name.content = name;
    return this;
  }
  getOption() {
    return this.Option.content;
  }
  setOption(data) {
    this.Option.content = data;
    return this;
  }
  update(variation) {
    if (variation && this.getName() === variation.getName()) this.setOption(variation.getOptions());
    return this;
  }
}